import {Grid} from '../custom/env/scenarios';
import {Subject} from 'rxjs/Subject';

declare var THREE: any;

interface IEnvCache {
  [key: string]: any;
}

export interface IEnvLoadResult {
  scene: any;
  name: string;
}

type SceneTransform = (scene, name: string) => any;

export class EnvLoader {

  private envCache: IEnvCache = {};
  private baseEnvPath: string;
  private meshLoader;
  public readonly onLoaded: Subject<IEnvLoadResult>;
  private sceneTransform: SceneTransform;

  constructor(baseEnvPath: string, sceneTransform?: SceneTransform) {
    this.baseEnvPath = baseEnvPath;
    this.onLoaded = new Subject<any>();
    const imageResolver = (imageInfo, texturePath: string): string => `${texturePath}/high-${imageInfo.sourceFile}`;
    this.meshLoader = new THREE.ObjectLoader(undefined, imageResolver);
    this.envCache['grid'] = new Grid();
    this.sceneTransform = sceneTransform || ((scene) => scene);
  }

  private loadRecources(urls: string[], loader): Promise<any>[] {
    return urls.map(url => new Promise((ok, fail) => loader.load(url, ok, null, fail)));
  }

  async load(name: string): Promise<any> {

    if (this.envCache[name]) {
      return this.envCache[name];
    }

    const basePath = `${this.baseEnvPath}${name}`;

    this.meshLoader.setTexturePath(basePath);

    const scene = await this.loadRecources([
      `${basePath}/scene.json`
    ], this.meshLoader)[0];

    const transformedScene = this.sceneTransform(scene, name);

    transformedScene.name = 'environment';

    this.envCache[name] = transformedScene;

    this.onLoaded.next({
      scene: transformedScene,
      name
    });

    return transformedScene;
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/EnvLoader.ts